import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { CoronaDispatch, CoronaState } from './store'

type DispatchFunc = () => CoronaDispatch
export const useCoronaDispatch: DispatchFunc = useDispatch
export const useCoronaSelector: TypedUseSelectorHook<CoronaState> = useSelector
